function ShowIf({ when, children }) {
  return when ? children : null;
}

export default ShowIf;
